module.exports = __webpack_public_path__ + "static/media/stb.56e4f022.png";